export const SELECT_THEME = 'theme/selected_theme';
